export default __webpack_public_path__ + "static/media/career_marketplace.4bcd6f8d.jpg";